(function () {
// Prevent duplicate event listeners on re-renders
if (window.__sizeGuideInitialized) return;
window.__sizeGuideInitialized = true;

var currentActivePicker = null;

function getOverlay() {
    return document.getElementById('size-guide-overlay');
}

function getBody() {
    var ov = getOverlay();
    return ov ? ov.querySelector('.sg-body') : null;
}

function getActivePicker(contextEl) {
    if (contextEl) {
        if (contextEl.matches && contextEl.matches('[data-size-picker]')) return contextEl;
        var found = contextEl.closest('[data-size-picker]') || contextEl.querySelector('[data-size-picker]');
        if (found) return found;
        var parentSection = contextEl.closest('[data-section], variant-selects, .product__info-container, .quick-add-modal, .product');
        if (parentSection) {
            var p = parentSection.querySelector('[data-size-picker]');
            if (p) return p;
        }
    }
    return currentActivePicker || document.querySelector('[data-size-picker]');
}

function getProductIdFromElement(el) {
    if (!el) return null;
    var prodEl = el.closest('[data-product-id]');
    if (prodEl && prodEl.getAttribute('data-product-id')) {
        return prodEl.getAttribute('data-product-id');
    }
    var trig = el.querySelector('[data-product-id]');
    if (trig && trig.getAttribute('data-product-id')) {
        return trig.getAttribute('data-product-id');
    }
    var sectionEl = el.closest('[data-section]');
    if (sectionEl) {
        var s = sectionEl.querySelector('[data-product-id]');
        if (s && s.getAttribute('data-product-id')) return s.getAttribute('data-product-id');
    }
    var globalSource = document.querySelector('[data-size-guide-source]');
    if (globalSource && globalSource.getAttribute('data-size-guide-source')) {
        return globalSource.getAttribute('data-size-guide-source');
    }
    return null;
}

function getOptionIndex(picker, input) {
    if (!picker || !input) return -1;
    if (picker.tagName && picker.tagName.toLowerCase() === 'select') {
        return Array.prototype.slice.call(picker.options).indexOf(input);
    } else {
        var inputs = Array.prototype.slice.call(picker.querySelectorAll('input[type="radio"]'));
        return inputs.indexOf(input);
    }
}

function decodeHtmlString(str) {
    if (typeof str !== 'string') return '';
    str = str.trim();

    // 1. Unwrap JSON string if double-encoded
    for (var i = 0; i < 3; i++) {
        if ((str.charAt(0) === '"' && str.charAt(str.length - 1) === '"') ||
            (str.charAt(0) === "'" && str.charAt(str.length - 1) === "'")) {
            try {
                var parsed = JSON.parse(str);
                if (typeof parsed === 'string') {
                    str = parsed.trim();
                } else {
                    break;
                }
            } catch (e) {
                str = str.substring(1, str.length - 1).trim();
            }
        }
    }

    // 2. Decode unicode escape sequences like \u003c, \u003e, \u0026, \u0022
    str = str.replace(/\\u003c/gi, '<')
             .replace(/\\u003e/gi, '>')
             .replace(/\\u0026/gi, '&')
             .replace(/\\u0022/gi, '"')
             .replace(/\\u0027/gi, "'")
             .replace(/\\"/g, '"')
             .replace(/\\'/g, "'")
             .replace(/\\n/g, '\n')
             .replace(/\\r/g, '')
             .replace(/\\t/g, ' ');

    // 3. If it contains HTML entities, decode them
    if (str.indexOf('&lt;') !== -1 && str.indexOf('&gt;') !== -1) {
        var txt = document.createElement('textarea');
        txt.innerHTML = str;
        str = txt.value;
    }

    return str;
}

function loadSizeGuideContent(productId, picker) {
    var body = getBody();
    if (!body) return false;

    var src = null;
    if (productId) {
        src = document.querySelector('[data-size-guide-source="' + productId + '"]') ||
              document.getElementById('SizeGuideData-' + productId) ||
              document.querySelector('#ProductSizeGuideData-' + productId);
    }
    if (!src && picker) {
        var parent = picker.closest('[data-section], variant-selects, .product__info-container, .product');
        if (parent) {
            src = parent.querySelector('[data-size-guide-source], [data-size-guide-raw]');
        }
    }
    if (!src) {
        src = document.querySelector('[data-size-guide-source], [data-size-guide-raw]');
    }

    if (!src) return false;

    var content = src.textContent || src.innerHTML || '';
    var finalHtml = '';

    try {
        var raw = JSON.parse(content);
        var extracted = typeof raw === 'object' && raw !== null && raw.sizeGuide !== undefined ? raw.sizeGuide : raw;
        finalHtml = decodeHtmlString(typeof extracted === 'string' ? extracted : JSON.stringify(extracted));
    } catch (e) {
        finalHtml = decodeHtmlString(content);
    }

    if (finalHtml) {
        body.innerHTML = finalHtml;
        return true;
    }

    return false;
}

function buildSizeGuideRadios(picker) {
    var body = getBody();
    var table = body && body.querySelector('table');
    if (!table) return;

    picker = picker || getActivePicker();
    var variantData = [];
    if (picker) {
        if (picker.tagName && picker.tagName.toLowerCase() === 'select') {
            Array.prototype.forEach.call(picker.options, function (opt) {
                var isOut = opt.disabled || opt.classList.contains('disabled') || opt.classList.contains('is-out-of-stock');
                variantData.push({
                    name: opt.text.trim(),
                    disabled: isOut
                });
            });
        } else {
            picker.querySelectorAll('input[type="radio"]').forEach(function (inp) {
                var lbl = document.querySelector('label[for="' + inp.id + '"]');
                var name = '';
                if (lbl) {
                    for (var ci = 0; ci < lbl.childNodes.length; ci++) {
                        var node = lbl.childNodes[ci];
                        if (node.nodeType === Node.TEXT_NODE && node.nodeValue.trim()) {
                            name = node.nodeValue.trim();
                            break;
                        }
                    }
                    if (!name) name = inp.value;
                } else {
                    name = inp.value;
                }
                var isOut = inp.disabled || inp.classList.contains('disabled') || inp.classList.contains('is-out-of-stock') || (lbl && (lbl.classList.contains('disabled-option') || lbl.classList.contains('is-out-of-stock')));
                variantData.push({
                    name: name,
                    disabled: isOut
                });
            });
        }
    }

    var rows = table.querySelectorAll('tr');
    var dataRowIndex = 0;
    rows.forEach(function (row, i) {
        if (i === 0) return; // header row
        var cells = row.querySelectorAll('td, th');
        if (!cells.length) return;

        var vData = variantData[dataRowIndex] || { name: '', disabled: false };
        var isOut = vData.disabled;

        var radioCell = cells[0];
        var radio = row.querySelector('.sg-size-radio');
        if (!radio) {
            radio = document.createElement('input');
            radio.type = 'radio';
            radio.name = 'sg-size-radio';
            radio.className = 'sg-size-radio';

            var nameSpan = document.createElement('span');
            nameSpan.className = 'sg-variant-label';
            nameSpan.textContent = vData.name || '';

            radioCell.innerHTML = '';
            radioCell.appendChild(radio);
            radioCell.appendChild(nameSpan);
        } else {
            var existingLabel = row.querySelector('.sg-variant-label');
            if (existingLabel) existingLabel.textContent = vData.name || '';
        }

        radio.value = dataRowIndex;
        row.setAttribute('data-sg-row', '');
        row.setAttribute('data-sg-index', dataRowIndex);

        var labelSpan = row.querySelector('.sg-variant-label');

        if (isOut) {
            radio.disabled = true;
            radio.classList.add('disabled', 'is-out-of-stock');
            row.classList.add('sg-row--disabled', 'is-out-of-stock');
            row.style.cssText = 'opacity: 0.45; cursor: not-allowed; background-color: #fafafa; color: #888;';
            if (labelSpan) {
                labelSpan.style.cssText = 'margin-left:6px; font-weight:600; vertical-align:middle; color:#888; text-decoration:line-through; cursor:not-allowed;';
            }
        } else {
            radio.disabled = false;
            radio.classList.remove('disabled', 'is-out-of-stock');
            row.classList.remove('sg-row--disabled', 'is-out-of-stock');
            row.style.cssText = '';
            if (labelSpan) {
                labelSpan.style.cssText = 'margin-left:6px; font-weight:600; vertical-align:middle; color:#222;';
            }
        }

        if (!row.dataset.sgListenerAdded) {
            row.dataset.sgListenerAdded = 'true';
            row.addEventListener('click', function (e) {
                if (radio.disabled) {
                    e.preventDefault();
                    e.stopPropagation();
                    return;
                }
                if (e.target !== radio) radio.checked = true;
            });
        }
        dataRowIndex++;
    });
}

function precheckRadioByIndex(index) {
    var body = getBody();
    if (!body || index === -1) return;
    var radios = body.querySelectorAll('.sg-size-radio');
    radios.forEach(function (r) {
        if (!r.disabled) {
            r.checked = parseInt(r.value, 10) === index;
        } else {
            r.checked = false;
        }
    });
}

function applySelection() {
    var picker = currentActivePicker || getActivePicker();
    if (!picker) return;
    var body = getBody();
    if (!body) return;
    var checkedRadio = body.querySelector('.sg-size-radio:checked');
    if (!checkedRadio || checkedRadio.disabled) return;
    var index = parseInt(checkedRadio.value, 10);

    if (picker.tagName && picker.tagName.toLowerCase() === 'select') {
        if (picker.options[index] && !picker.options[index].disabled) {
            picker.selectedIndex = index;
            picker.setAttribute('data-last-value', picker.options[index].value);
            picker.dispatchEvent(new Event('change', { bubbles: true }));
        }
    } else {
        var radios = Array.prototype.slice.call(picker.querySelectorAll('input[type="radio"]'));
        if (radios[index] && !radios[index].disabled) {
            radios[index].checked = true;
            radios[index].dispatchEvent(new Event('change', { bubbles: true }));
        }
    }
}

function open() {
    var overlay = getOverlay();
    if (!overlay) return;
    overlay.classList.add('is-open', 'is-active');
    overlay.setAttribute('aria-hidden', 'false');
    document.body.classList.add('sg-lock', 'sg-open');
    var closeBtn = overlay.querySelector('[data-sg-close]');
    if (closeBtn) closeBtn.focus();
}

function close() {
    var overlay = getOverlay();
    if (!overlay) return;
    overlay.classList.remove('is-open', 'is-active');
    overlay.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('sg-lock', 'sg-open');
}

function openForPicker(picker, clickedInput) {
    currentActivePicker = picker;
    var productId = getProductIdFromElement(picker) || (clickedInput && getProductIdFromElement(clickedInput));
    loadSizeGuideContent(productId, picker);
    buildSizeGuideRadios(picker);
    var index = getOptionIndex(picker, clickedInput);
    precheckRadioByIndex(index);
    open();
}

// Initialize select attributes
document.querySelectorAll('select[data-size-picker]').forEach(function (sel) {
    sel.setAttribute('data-last-value', sel.value);
});

/* Intercept clicks */
document.addEventListener(
    'click',
    function (e) {
        var overlay = getOverlay();
        if (!overlay) return;

        /* OK button: confirm the popup selection onto the real control */
        if (e.target.closest('[data-sg-ok]')) {
            applySelection();
            close();
            return;
        }
        /* Any other close control (X, backdrop) */
        if (e.target.closest('[data-sg-close]')) {
            close();
            return;
        }
        if (e.target === overlay) {
            close();
            return;
        }

        /* "Find Your Size" link/button */
        var trigger = e.target.closest('[data-size-guide-open]');
        if (trigger) {
            var productId = trigger.getAttribute('data-product-id') ||
                            trigger.closest('[data-product-id]')?.getAttribute('data-product-id') ||
                            getProductIdFromElement(trigger);
            var linkedPicker = getActivePicker(trigger);
            currentActivePicker = linkedPicker;

            loadSizeGuideContent(productId, linkedPicker);
            var currentInput = null;
            if (linkedPicker) {
                if (linkedPicker.tagName && linkedPicker.tagName.toLowerCase() === 'select') {
                    currentInput = linkedPicker.options[linkedPicker.selectedIndex];
                } else {
                    currentInput = linkedPicker.querySelector('input[type="radio"]:checked');
                }
            }
            openForPicker(linkedPicker, currentInput);
            return;
        }

        /* Clicks directly on the size swatch/pill options */
        var picker = e.target.closest('[data-size-picker]');
        if (!picker) return;
        if (picker.tagName && picker.tagName.toLowerCase() === 'select') return; // handled by change listener below

        var input = null;
        if (e.target.matches('input[type="radio"]')) {
            input = e.target;
        } else {
            var label = e.target.closest('label');
            if (label) {
                var forId = label.getAttribute('for');
                if (forId) {
                    input = picker.querySelector('[id="' + forId + '"]') || document.getElementById(forId);
                }
                if (!input) {
                    input = label.previousElementSibling;
                    if (input && input.tagName && input.tagName.toLowerCase() !== 'input') {
                        input = label.nextElementSibling;
                    }
                    if (!input || !input.tagName || input.tagName.toLowerCase() !== 'input') {
                        var sizeText = (label.textContent || '').trim();
                        var radios = picker.querySelectorAll('input[type="radio"]');
                        radios.forEach(function (r) {
                            if (r.value === sizeText) input = r;
                        });
                    }
                }
            }
        }
        if (!input) return;

        // IF VARIANT IS OUT OF STOCK -> DO NOT OPEN POPUP!
        var isOut = input.disabled || input.classList.contains('disabled') || input.classList.contains('is-out-of-stock');
        if (isOut) {
            e.preventDefault();
            e.stopPropagation();
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();
            return;
        }

        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        openForPicker(picker, input);
    },
    true
);

/* Clicks directly on a size <select> dropdown */
document.addEventListener(
    'change',
    function (e) {
        var picker = e.target;
        if (!picker.matches || !picker.matches('select[data-size-picker]')) return;

        var selectedOption = picker.options[picker.selectedIndex];
        var previous = picker.getAttribute('data-last-value') || '';

        // If out of stock, do not open popup
        if (selectedOption && (selectedOption.disabled || selectedOption.classList.contains('disabled') || selectedOption.classList.contains('is-out-of-stock'))) {
            e.stopPropagation();
            if (e.stopImmediatePropagation) e.stopImmediatePropagation();
            return;
        }

        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        picker.value = previous; // revert until confirmed via OK
        openForPicker(picker, selectedOption);
    },
    true
);

/* Esc + overlay-click to close */
document.addEventListener('click', function (e) {
    var overlay = getOverlay();
    if (e.target.closest('[data-sg-close]') || e.target === overlay) close();
});
document.addEventListener('keydown', function (e) {
    var overlay = getOverlay();
    if (e.key === 'Escape' && overlay && (overlay.classList.contains('is-open') || overlay.classList.contains('is-active'))) close();
});
})();
